import { createStyles } from "../theme";
import { Col } from "../lib";

type Props = {
  value: boolean;
  loading?: boolean;
};

export function OnlineDot({ value, loading }: Props) {
  return (
    <Col
      style={[$.container, loading ? $.loading : value ? $.online : $.offline]}
    />
  );
}

const dotSize = 18;

const $ = createStyles({
  container: {
    width: dotSize,
    height: dotSize,
    borderRadius: dotSize / 2,
  },
  online: {
    backgroundColor: "online",
  },
  offline: {
    backgroundColor: "offline",
  },
  loading: {
    backgroundColor: "overlay",
  },
});
